import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmService } from '../services/confirm.service';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  if (!component.hasUnsavedChanges()) return true;
  return inject(ConfirmService).confirm({
    title: 'Unsaved changes',
    message: 'You have unsaved changes. Leave without saving?',
    confirmText: 'Leave',
    cancelText: 'Stay',
    variant: 'destructive',
  });
};
